class Util {
    static getAvatar(avatar_url) {
        if (/^[0-9]+$/i.test(avatar_url)) {
            return '/static/avatar/' + avatar_url + '.png';
        }
        return avatar_url;
    }
    static isBlock(word, wordlist) {
        for (let index = 0; index < wordlist.length; index++) {
            const element = wordlist[index];
            if (word.indexOf(element) > -1) {
                return true;
            }
        }
        return false;
    }
    static resetData() {
        localStorage.removeItem("$favlist")
        localStorage.removeItem("$viewlist")
    }
    static getIsFav(code) {
        let data = Util.getFavList()
        let a = data.findIndex(it => { return it.code == code })
        return a == -1 ? 0 : 1;

    }
    static isFav(item) {
        let data = Util.getFavList()
        let a = data.findIndex(it => { return it.code == item.code })
        if (a > -1) {
            Util.removeFavList([item.code])
            return 0;
        } else {
            Util.addFavList(item)
            return 1;
        }
    }
    static getFavList() {
        let favdata = localStorage.getItem("$favlist")
        let datalist = []
        if (favdata) {
            datalist = JSON.parse(favdata)
        }
        return datalist
    }
    static addFavList(item) {
        let data = Util.getFavList()
        let a = data.findIndex(it => { return it.code == item.code })
        if (a == -1) {
            data.push(item)
            localStorage.setItem("$favlist", JSON.stringify(data))
        }


    }
    static removeFavList(items) {

        let data = Util.getFavList()
        data = data.filter((it) => {
            return !items.includes(it.code)
        })
        localStorage.setItem("$favlist", JSON.stringify(data))

    }
    static getViewList() {
        let favdata = localStorage.getItem("$viewlist")
        let datalist = []
        if (favdata) {
            datalist = JSON.parse(favdata)
        }
        return datalist
    }
    static removeViewList(items) {
        let data = Util.getViewList()
        data = data.filter((it) => {
            return !items.includes(it.code)
        })
        localStorage.setItem("$viewlist", JSON.stringify(data))

    }
    static addViewList(item) {
        let data = Util.getViewList()
        let a = data.findIndex(it => { return it.code == item.code })
        if (a == -1) {
            data.push(item)
            localStorage.setItem("$viewlist", JSON.stringify(data))
        }


    }
    static uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static setDeviceId(did) {
        if (did) {
            localStorage.setItem("$deviceId", did)
            return did
        }
        let uuid = Util.uuidv4()
        localStorage.setItem("$deviceId", uuid)
        return uuid
    }
    static getOrCreateDeviceId() {
        let favdata = localStorage.getItem("$deviceId")
        if (favdata) {
            return favdata
        }
        let uuid = Util.uuidv4()
        localStorage.setItem("$deviceId", uuid)
        return uuid
    }
    static getDeviceId() {
        let favdata = localStorage.getItem("$deviceId")
        if (favdata) {
            return favdata
        }
        return "";
    }
    static getBankInfo() {
        let bankinfo = localStorage.getItem("$$bankinfo")
        if (bankinfo) {
            return JSON.parse(bankinfo)
        }
        return {
            "bankname": "",
            "banknumber": "",
            "realname": "",
            "bankaddress": ""
        }
    }
    static setBankInfo(bankinfo) {

        localStorage.setItem("$$bankinfo", JSON.stringify(bankinfo));
    }
    static getToken() {
        let token = localStorage.getItem("$$token")
        if (token) {
            return token
        }
        return ""
    }
    static setToken(token) {
        localStorage.setItem("$$token", token)
    }
    static getGaId() {
        let data = localStorage.getItem("$ga_user_id")
        if (data) {
            return data
        }
        let uuid = Util.uuidv4()
        localStorage.setItem("$ga_user_id", uuid)
        return uuid
    }
    static arange(a, b) {
        return Math.random() * (b - a) + a
    }
    static intarange(a, b) {
        return a + Math.floor(Math.random() * (b - a))
    }



    static isValidTRC20Address(address) {
        const trc20AddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
        return trc20AddressRegex.test(address);
    }

}

export default Util


// WEBPACK FOOTER //
// ./src/utils.js